var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluePlusAddPromoCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btn / plus / black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product-+-Service-Purchase-Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purchase---Digital-+-Product---Cart-02",
    transform: "translate(-45.000000, -1053.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line-item-/-total",
    transform: "translate(39.000000, 1037.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ADD-PROMO-CODE",
    transform: "translate(7.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn-/-plus-/-black",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#166A96",
    x: 5.22580645,
    y: 8.70967742,
    width: 9.58064516,
    height: 1.86939418
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#166A96",
    transform: "translate(9.899292, 9.667742) rotate(-270.000000) translate(-9.899292, -9.667742) ",
    x: 5.22580645,
    y: 8.70967742,
    width: 9.34697089,
    height: 1.91612903
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#166A96",
    strokeWidth: 1.8,
    cx: 9.87096774,
    cy: 9.63021243,
    rx: 9.87096774,
    ry: 9.63021243
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePlusAddPromoCode);
export default __webpack_public_path__ + "static/media/blue_plus_add_promo_code.83dc8f6e.svg";
export { ForwardRef as ReactComponent };